// @core/api/endpoints/task/remove_dependency.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Remove dependency
 * Removes a dependency relationship between tasks. Both tasks remain but are no longer linked.
 */
export async function RemoveDependency(
  task_id: string,
  dependency_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/dependencies/:dependency_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':dependency_id', encodeURIComponent(dependency_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
